import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { IconDirective, PopoverRef, ButtonDirective } from 'shared/ui-common';

import { POPOVER_DATA } from '@treetop/shared/model';

import { CommentType } from '../../comment.model';

export type AddCommentPopoverData = {
  allowedTypes: CommentType[];
};

@Component({
  selector: 'tt-add-comment-popover',
  templateUrl: './add-comment-popover.component.html',
  styleUrls: ['./add-comment-popover.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, IconDirective, TranslocoPipe, ButtonDirective],
})
export class AddCommentPopoverComponent {
  protected popoverRef = inject(PopoverRef);
  private data = inject<AddCommentPopoverData | undefined>(POPOVER_DATA);
  protected readonly CommentType = CommentType;
  protected allowedTypes = this.data?.allowedTypes ?? [CommentType.Comment];
}
